import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: `ログインIDまたは、共済契約者番号`,
    keyword: "userId",
    type: "label",
    inputProps: { maxLength: 85 },
  },
];
const schemaKeiYaKuSya = {
  userId: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0057E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

export { schemaKeiYaKuSya, fakeTableList };
